import { config } from '@react-spring/web';
import classNames from 'classnames';
import type { PropsWithChildren } from 'react';
import { BaseModal } from './base-modal';

type BottomSheetProps = {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  label?: string;
};

export const BottomSheet = ({ children, isOpen, onClose, className, label }: PropsWithChildren<BottomSheetProps>) => (
  <BaseModal
    isOpen={isOpen}
    label={label}
    onClose={onClose}
    className={classNames('tds-bottom-sheet h-auto bottom-0 flex flex-col gap-500 pt-400 px-300', className)} // bottom padding defined in css to include safe-area
    animation={{
      from: { y: 150 },
      enter: { y: 0 },
      leave: { y: 150 },
      config: config.stiff,
    }}
    dismissable={true}
    zIndexIncrease={20}>
    {children}
  </BaseModal>
);
